module.exports = __webpack_public_path__ + "media/images/inquiry/header-406b2d5e6ec5f5ccc9737d1446aab3bc.jpg";